import { useSyncExternalStore } from 'react';
import {
  getMessengerSidebarUnreadViewportSubtract,
  subscribeMessengerSidebarUnreadViewportSubtract,
} from '@/components/Messenger/cache/messengerSidebarUnreadViewportStore';

export function useMessengerSidebarUnreadViewportSubtract() {
  return useSyncExternalStore(
    subscribeMessengerSidebarUnreadViewportSubtract,
    getMessengerSidebarUnreadViewportSubtract,
    getMessengerSidebarUnreadViewportSubtract
  );
}
